<template>
  <div class="image-box" ref="image">
    <croppa
        class="croppa"
        v-model="croppa"
        :width="croppaWidth"
        :height="croppaHeight"
        placeholder="Одно мгновение..."
        :placeholder-font-size="0"
        :disabled="false"
        :zoom-speed="8"
        :prevent-white-space="true"
        :show-remove-button="false"
        initial-size="cover"
    >
      <img crossOrigin="anonymous"
           :src="getUrl"
           slot="initial">
    </croppa>
    <div class="bottom-bar">
      <div class="bottom-bar_title" :title="getName">
       {{ getName }}
      </div>
      <div class="bottom-bar_btns">
        <el-button-group>
          <el-button @click="croppa.zoomIn()" icon="el-icon-plus"></el-button>
          <el-button @click="croppa.zoomOut()" icon="el-icon-minus"></el-button>
        </el-button-group>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-croppa/dist/vue-croppa.css'
import Vue from 'vue'
import Croppa from 'vue-croppa'

Vue.use(Croppa)

export default {
  name: "ImageCopper",
  props: {
    image: {
      required: true
    }
  },
  data() {
    return {
      croppa: null,
      loading: false,
      croppaWidth: 100,
      croppaHeight: 525
    }
  },
  watch: {},
  computed: {
    getUrl() {
      return this.$root.getUrlPhoto(this.image.link.get)
    },
    getName() {
      return this.image.field
    }
  },
  mounted() {
    this.croppaWidth = this.$refs.image.offsetWidth
    this.croppaHeight = this.$refs.image.offsetHeight

  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.image-box {
  width: 100%;
  height: 100%;

  border-radius: 4px;
  position: relative;
  overflow: hidden;

/deep/ .croppa-container canvas {
  &:after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: transparent;
    background-image: linear-gradient(to left, #11de93, #0e7ad6);
    opacity: 0.8;
  }
}

}
.bottom-bar {
  width: calc(100% - 32px);
  padding: 10px 16px;

  position: absolute;
  left: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background-image: linear-gradient(to bottom, #03030300, rgba(40, 39, 39, 0.93));


  &_title {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    color: #fff;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &_btns {
    min-width: 83px;
    /deep/ .el-button {
      background: #fff !important;
      border: 0 !important;
    }
  }

}
</style>
